var map = {
	"./HEADER RENAULT mehanika 1.jpg": 2888,
	"./HEADER RENAULT mehanika 2.jpg": 5735,
	"./RENAULT hodnik.JPG": 7266,
	"./RENAULT limarija 1.JPG": 5797,
	"./RENAULT limarija 2.JPG": 1610,
	"./RENAULT limarija 3.JPG": 3399,
	"./RENAULT mehanika 3.jpg": 2711,
	"./RENAULT mehanika 4.JPG": 1327,
	"./RENAULT mehanika 5.JPG": 4834,
	"./RENAULT mehanika 6.jpg": 2062
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47;